<section class="section faqsection" [ngClass]="bannerClass">
	<div class="container">
		<div class="row">
			<div
				class="col-md-10 col-sm-11 col-11 m-auto"
				data-aos="fade-up"
				data-aos-duration="1000"
				data-aos-delay="100"
			>
				<div class="row">
					<div class="col-lg-4 col-md-6 col-sm-6">
						<div class="creative">
							<h2 class="" [ngClass]="h1text">
								What <br />
								makes Pixtar <br />
								Special? <br />
								<span> And other FAQs… </span>
							</h2>
						</div>
					</div>
					<div class="col-lg-7 offset-lg-1 col-md-6 col-sm-6">
						<div class="d-block">
							<div class="custom-collapse footer-collapse">
								<div class="accordion" id="accordionExample1">
									<div class="accordion-item">
										<h3 class="accordion-header" id="headingOne">
											<button
												class="accordion-button collapsed brdtp px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseOne"
												aria-expanded="false"
												aria-controls="collapseOne"
											>
												Alright, no secrets – what makes Pixtar stand out?
											</button>
										</h3>
										<div
											id="collapseOne"
											class="accordion-collapse collapse"
											aria-labelledby="headingOne"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Pixtar stands out for our unique blend of creativity,
												strategy, and a deep commitment to client satisfaction.
												We don’t just design; we craft memorable, user-friendly
												experiences that make brands shine.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingTwo">
											<button
												class="accordion-button collapsed px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseTwo"
												aria-expanded="false"
												aria-controls="collapseTwo"
											>
												Where are you based?
											</button>
										</h3>
										<div
											id="collapseTwo"
											class="accordion-collapse collapse"
											aria-labelledby="headingTwo"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Virtually, next door! We’re proudly based in Dubai, UAE,
												but our team collaborates with clients worldwide, making
												distance no barrier to outstanding design! Our business
												hours are 9 am–6 pm GST / 1 am–10 am EST / 10 pm–7 am
												PST. But with our early-rising CEO and night-owl CTO,
												we’re always able to sync up with clients from LA all
												the way to Australia—and all the lovely places in
												between.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingThree">
											<button
												class="accordion-button collapsed px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseThree"
												aria-expanded="false"
												aria-controls="collapseThree"
											>
												How are you different from a freelance designer?
											</button>
										</h3>
										<div
											id="collapseThree"
											class="accordion-collapse collapse"
											aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												At Pixtar, you get the expertise of an entire team, not
												just one individual. We bring together specialized
												skills in design, strategy, and development, providing a
												more comprehensive approach and smoother project
												delivery.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingFour">
											<button
												class="accordion-button collapsed px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseFour"
												aria-expanded="false"
												aria-controls="collapseFour"
											>
												What other design magic do you offer?
											</button>
										</h3>
										<div
											id="collapseFour"
											class="accordion-collapse collapse"
											aria-labelledby="headingFour"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												Besides website design, we specialize in branding, UI/UX
												design, graphic design, and digital marketing assets.
												Whatever your design needs, Pixtar has the creative
												solution.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingFive">
											<button
												class="accordion-button collapsed px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseFive"
												aria-expanded="false"
												aria-controls="collapseFive"
											>
												Who do you usually work with?
											</button>
										</h3>
										<div
											id="collapseFive"
											class="accordion-collapse collapse"
											aria-labelledby="headingFive"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												We collaborate with businesses of all sizes—from
												startups to established brands—across a range of
												industries, including Lifestyle, healthcare, technology,
												real estate, and more.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSix">
											<button
												class="accordion-button collapsed px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseSix"
												aria-expanded="false"
												aria-controls="collapseSix"
											>
												Which platforms do you use for building websites?
											</button>
										</h3>
										<div
											id="collapseSix"
											class="accordion-collapse collapse"
											aria-labelledby="headingSix"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												We work with popular platforms like Angular, Node.js,
												React, Shopify, Magento, and Webflow, ensuring you get a
												website that’s not only beautiful but also easy to
												manage and scalable.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h3 class="accordion-header" id="headingSeven">
											<button
												class="accordion-button collapsed brdbtm px-3"
												type="button"
												data-bs-toggle="collapse"
												data-bs-target="#collapseSeven"
												aria-expanded="false"
												aria-controls="collapseSeven"
											>
												I’m in! When can we get started?
											</button>
										</h3>
										<div
											id="collapseSeven"
											class="accordion-collapse collapse"
											aria-labelledby="headingSeven"
											data-bs-parent="#accordionExample1"
										>
											<div class="accordion-body">
												We’re thrilled to have you onboard! Just reach out
												through our contact page, and we’ll set up a kickoff
												meeting to dive into your project.
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
